import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSubmissionUnpublishDialogWrapper = styled.div`
  max-width: 1278px;

  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 42px;

  padding: 64px 233px;

  border-radius: 30px;
  background: linear-gradient(
    0deg,
    #fff 0%,
    rgba(223, 227, 238, 1) 50%,
    rgba(139, 157, 195, 1) 100%
  );

  ${BREAKPOINTS.tablet} {
    padding: 16px;
    max-width: 100%;

    top: 16px;
    left: 16px;
    right: 16px;
    bottom: 16px;

    transform: translate(0%, 0%);
  }

  z-index: 99999999;
`;

export const ResourceSubmissionUnpublishDialogIconContainer = styled.div`
  width: 70px;
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: var(--color-data-company-background);
  border-radius: 100%;
`;

export const ResourceSubmissionUnpublishDialogText = styled.h4`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;
  text-align: center;

  color: #000;
`;

export const ResourceSubmissionUnpublishDialogButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 71px;

  ${BREAKPOINTS.tablet} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ResourceSubmissionUnpublishDialogButton = styled.button`
  width: 100%;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  padding: 16px 48px;

  border-radius: 100px;
`;

export const ResourceSubmissionUnpublishDialogButtonText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-wrap: nowrap;

  color: var(--color-text);
`;

export const ResourceSubmissionUnpublishDialogButtonCancel = styled(
  ResourceSubmissionUnpublishDialogButton
)`
  border: 2px solid var(--color-primary);
`;

export const ResourceSubmissionUnpublishDialogButtonConfirm = styled(
  ResourceSubmissionUnpublishDialogButton
)`
  border: 2px solid var(--color-primary);
`;
